export default __webpack_public_path__ + "static/media/Topicks.7d1c174c.png";